/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { INamed } from '../../../core/models/common/INamed';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30Header } from './Oas30Header';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class Oas30Encoding extends ExtensibleNode implements INamed {
    /*private*/ _name : string;

    public contentType : string;

    public headers : any = <any>({});

    public style : string;

    public explode : boolean;

    public allowReserved : boolean;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this.contentType===undefined) this.contentType = null;
        if(this.style===undefined) this.style = null;
        if(this.explode===undefined) this.explode = null;
        if(this.allowReserved===undefined) this.allowReserved = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitEncoding(this);
    }

    /**
     * Creates a header.
     * @param {string} name
     * @return {Oas30Header}
     */
    public createHeader(name : string) : Oas30Header {
        let rval : Oas30Header = new Oas30Header(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a header.
     * @param {string} name
     * @param {Oas30Header} header
     */
    public addHeader(name : string, header : Oas30Header) {
        /* put */(this.headers[name] = header);
    }

    /**
     * Gets a single header by name.
     * @param {string} name
     * @return {Oas30Header}
     */
    public getHeader(name : string) : Oas30Header {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.headers, name);
    }

    /**
     * Gets the header names.
     * @return {string[]}
     */
    public getHeaderNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.headers));
        return rval;
    }

    /**
     * Removes a single header and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30Header}
     */
    public removeHeader(name : string) : Oas30Header {
        return /* remove */(map => { let deleted = this.headers[name];delete this.headers[name];return deleted;})(this.headers);
    }

    /**
     * Gets a list of all headers.
     * @return {Oas30Header[]}
     */
    public getHeaders() : Array<Oas30Header> {
        let rval : Array<Oas30Header> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.headers));
        return rval;
    }
}
Oas30Encoding["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Encoding";
Oas30Encoding["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




